import AbstractRestApi from '@/api/RestApi/AbstractRestApi'
import ResponseHandler from '@/api/response/ResponseHandler'
import apiClient from '@/api/ApiClient'

class ResidentialCanteenRelationsApiClient extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/residential-canteen-partner-relations'
    }

    list() {
        return ResponseHandler.handle(
            apiClient.get(this.getBaseUrl()).then((data) => {
                return data
            })
        )
    }
}

export default new ResidentialCanteenRelationsApiClient()
